<template>
    <div>
        <h4>Materias de Divulgação</h4>
        <b-card>
            <b-card-body>
                <b-row>
                    <b-button variant="primary" size="sm" @click="openModal()"><i class="fas fa-plus"></i> Adicionar</b-button>
                </b-row>
                <b-row class="mt-3 text-center md-10">
                        <b-table v-if="lista.length > 0" striped hover :items="lista" :fields="header" :busy="loadingTable">
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Carregando ...</strong>
                                </div>
                            </template>
                            <template #cell(actions)="row">
                                <b-button v-if="row.item.tipo == 'VIDEO'" variant="primary" size="sm"  @click="detalhar(row.item)"><i class="fab fa-youtube"></i></b-button>
                                <b-button v-else-if="row.item.tipo == 'IMAGEM'" variant="primary" size="sm" @click="detalhar(row.item)"><i class="fas fa-image"></i></b-button>
                                <b-button v-else-if="row.item.tipo == 'PDF'" variant="primary" size="sm" @click="detalhar(row.item)"><i class="fas fa-file-pdf"></i></b-button>                            
                            </template>
                            <template #cell(delete) = "row">
                                <b-button variant="warning" size="sm" title="Editar" @click="editar(row.item)"><i class="fas fa-edit"></i></b-button>
                                <b-button variant="secondary" title="Excluir" size="sm" @click="excluir(row.item.id)"><i class="fas fa-trash"></i></b-button>
                            </template>
                        </b-table>
                   
                </b-row>
            </b-card-body>
        </b-card>

        <b-modal v-model="modalAdd" size="xl">
            <div>
                <b-row>
                    <b-col>
                        <label for="">Título</label>
                        <b-form-input placeholder="Título" v-model="titulo"></b-form-input>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col>
                        <label for="desc">Descrição</label>
                        <b-form-textarea
                            id="desc"
                            v-model="descricao"
                            placeholder="Descreva o material..."
                            rows="3"
                            max-rows="6"
                        />
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col>
                        <label for="camp">Campanha</label>
                        <b-form-input
                            id="camp" 
                            placeholder="Código da Campanha" 
                            v-model="campanha">
                        </b-form-input>
                    </b-col>
                    <b-col>
                        <label for="class">Classe Distribuidor</label>
                        <b-form-select v-model="classe" :options="opcoesClasse"></b-form-select>
                    </b-col>
                    <b-col>
                        <label for="class">Tipo de Material</label>
                        <b-form-select v-model="tipo" :options="opcoesTipo"></b-form-select>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col v-show="tipo === 'VIDEO'">
                        <label for="vid">Link do Video</label>
                        <b-form-input id="vid" v-model="urlVideo" ></b-form-input>
                    </b-col>
                    <b-col v-show="tipo === 'IMAGEM' || tipo === 'PDF'">
                        <b-form-group description="Tamanho Máximo: 25Mb  -  Tipo: PDF, PNG, JPG, JPEG ">
                            <label for="arq">Arquivo</label>
                            <b-form-file 
                                @change="onFileChange" 
                                :state="Boolean(newMaterialDownload.file)" 
                                placeholder="Selecione um Arquivo..."                                
                            />  
                        </b-form-group>                       
                    </b-col>
                </b-row>
            </div>
            <template #modal-header>
                <h4> Adicionar Material de Divulgação </h4>
            </template>

            <template #modal-footer>
                <b-button :disabled="loading" variant="success" size="sm" @click="adicionar">
                    <b-spinner small v-if="loading"></b-spinner>
                    <span v-if="id"> 
                        <i class="fas fa-save"></i>
                        Salvar
                    </span>
                    <span v-else>
                        <i class="fas fa-plus"></i>
                        Adicionar
                    </span>
                </b-button>
                <b-button variant="danger" size="sm" @click="modalAdd = false"> Cancelar</b-button>            
            </template>
        </b-modal>

        <!-- Modal de visualização -->
        <b-modal v-model="modalVer" size="xl">
            <template #modal-header>
                <div>
                    {{ itemModal.titulo }}
                </div>
            </template>
            <b-row>
               <b> Descrição:  &nbsp; </b> {{ itemModal.descricao }}
            </b-row>
            <b-row class="mt-3" v-if="itemModal.tipo === 'VIDEO'">
                <b-col class="mt-2 col-md-12 text-center">
                    <div>
                        <b-embed
                            type="iframe"
                            aspect='21by9'
                            :src="itemModal.path"
                            allowfullscreen
                        />
                    </div>
                </b-col>
            </b-row>
            <b-row v-else>
                <b-col class="mt-2 col-md-12 text-center">
                    <div>
                        <b-img fluid :src="itemModal.path"></b-img>
                    </div>
                </b-col>
            </b-row>
            <template #modal-footer>
                <b-button size="sm" variant="danger" @click="modalVer = false">Fechar</b-button>
            </template>     
        </b-modal>
    </div>
</template>

<script>
export default {
    props: {},
    data() {
        return {
            modalVer: false,
            opcoesTipo: [
                {
                    value: null,
                    text: 'Selecione o tipo de Material',
                },
                {
                    value: 'VIDEO',
                    text: 'Video'
                },
                {
                    value: 'IMAGEM',
                    text: 'Imagem'
                },
                {
                    value: 'PDF',
                    text: 'PDF'
                },
            ],
            opcoesClasse: [
                {
                    value: null,
                    text: 'Selecione a classe'
                },
                {
                    value: 'G',
                    text: 'G'
                },
                {
                    value: 'A',
                    text: 'A'
                },
                {
                    value: 'TODAS',
                    text: 'TODAS'
                }
            ],
            header: [
                {
                    key: "actions",
                    class: "text-center",
                    label: ""
                },
                {
                    key:'id',
                    class: "text-center",
                    label: 'Código'
                },
                {
                    key:'titulo',
                    class: "text-center",
                    label: 'Titulo'
                },
                {
                    key:'tipo',
                    class: "text-center",
                    label: 'Tipo',
                    sortable: true
                },
                {
                    key:"campanha.codigo",
                    class: "text-center",
                    label: "Campanha",
                    sortable: true
                },
                {
                    key:'classe_distribuidor',
                    class: "text-center",
                    label: 'Classe',
                    sortable: true
                },
                {
                    key:'ativo',
                    label: 'Status',
                    formatter: (value) => {
                        return value ? 'Ativo' : 'Bloqueado';
                    },
                    sortable: true
                },
                {
                    key: 'delete',
                    class: "text-center",
                    label: ''
                }
            ],
            overlay: 'light',
            modalAdd: false,
            descricao: '',
            classe:null,
            tipo: null,
            campanha: null,
            urlVideo: null,
            titulo: '',
            id: null,
            newMaterialDownload: {
                descricao: "",
                file: ""
            },
            loading: false,
            lista: [],
            loadingTable: false,
            load: false,
            itemModal: {}
        }
    },

    methods: {
        editar(item) {
            this.classe = item.classe_distribuidor;
            this.tipo = item.tipo;
            this.campanha = item.campanha.codigo;
            this.urlVideo = item.tipo === 'VIDEO' ? item.path : null;
            this.arquivo = item.tipo !== 'VIDEO' ? item.path : null;
            console.log(this.arquivo);
            this.descricao = item.descricao,
            this.modalAdd = true;
            this.titulo = item.titulo;
            this.id = item.id
        },
        download(id) {
            axios.get('/material-divulgacao/download/' + id)
                .then((response) => {
                    window.open(response.data.url, '_blank');
                })
                .catch((erro) => {
                    console.log(erro);
                })
        },

        detalhar(item) {
            if(item.tipo != 'VIDEO'){
                this.download(item.id);
            } else {
                this.itemModal = item;
                this.modalVer = true;
            }
        },  
        onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.newMaterialDownload.file = files[0];
            this.createFile(files[0]);
        },
        createFile(file) {
            this.arquivoUpload = file.name;
        },
        openModal() {
            this.id = null;
            this.classe= null;
            this.tipo = null;
            this.campanha = null;
            this.urlVideo = null;
            this.arquivo = null;
            this.descricao = '',
            this.modalAdd = !this.modalAdd;
            this.titulo = null
        },
        
        excluir(id) {
            const vm = this;
            vm.$swal({
                icon: 'warning',
                title: 'Atenção',
                text: 'Deseja realmente excluir este material?',
                showCancelButton: true,
                confirmButtonText: 'Sim, Excluir',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.value) {
                    vm.load = true
                    axios.delete('/adm/material-divulgacao/'+id).then((response) => {
                        vm.getMateriais();
                    }).catch((erro) => {

                    })
                }
            }).catch((error) => {
                console.log(error);
                vm.$swal('Atenção','erro ao excluir material!', 'error');
            }).finally(() => {
                this.load = false;
            })
        },
        getMateriais() {
            const vm = this;
            vm.loadingTable = true
            axios.get('/adm/material-divulgacao/listar')
                .then((response) => {
                    // console.log(response.data);
                    vm.lista = response.data;
                }).catch((erro) => {
                    console.log(erro)
                    vm.$swal('Atenção','erro ao listar materiais', 'error');
                }).finally(() => {
                    vm.loadingTable = false;
                })
        },

       adicionar() {
            const vm = this;            
            var form = new FormData();
            form.append("titulo", this.titulo);
            form.append("descricao", this.descricao);
            form.append("file", this.newMaterialDownload.file);
            form.append("classe", this.classe);
            form.append("tipo", this.tipo);
            form.append("campanha", this.campanha);
            form.append("urlVideo", this.urlVideo);
            form.append("id", this.id);
            this.loading = true;            
            let $url = '/adm/material-divulgacao'        
            // console.log(form)

            axios
                .post($url, form)
                .then(function (response) {
                    // console.log('response', response); 
                    vm.getMateriais();
                    vm.modalAdd = false;
                }).catch((erro) => {
                    const error = erro.response.data.errors;
                    console.log(error);
                    if(typeof error === 'object'){
                        this.$swal.fire({
                            title: 'Atenção!',
                            icon: 'error',
                            html:   'Todos os campos devem ser preenchidos!'
                        })
                    } else {
                        vm.$swal('Atenção', error, 'error');
                    }
                }).finally(() => {
                    vm.loading = false;
                })
       },
    },
    mounted() {
        this.getMateriais();
    },
}

</script>


// WEBPACK FOOTER //
// resources/assets/js/components/material_divulgacao/Main.vue